<div
  class="flex justify-center h-auto p-[29px] !pl-0 !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]"
>
  <div class="!p-[30px] !pb-0 !pl-0 !rounded-[15px] w-full !pt-[0px]">
    <h3 class="text-[20px] font-semibold !pl-0 !mb-[0px] !pt-0">
      Applicant Details
    </h3>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2">
      <div class="pr-5">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
            <input readonly="true" matInput placeholder="Company Name" />
          </mat-form-field>
        </div>
      </div>
      <div class="pr-5">
        <div class="rounded pr-10 !mb-[40px]">
          <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
            <input readonly="true" matInput placeholder="Contact Person" />
          </mat-form-field>
        </div>
      </div>

      <div class="pr-5">
        <div class="rounded pr-10 !mb-[40px]">
          <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
            <input
              readonly="true"
              matInput
              placeholder="Company Registration Number"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="pr-5">
        <div class="rounded pr-10 !mb-[40px]">
          <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
            <input readonly="true" matInput placeholder="Position" />
          </mat-form-field>
        </div>
      </div>

      <div class="pr-5">
        <div class="rounded pr-10 !mb-[40px]">
          <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
            <input
              readonly="true"
              matInput
              placeholder="VAT Registration Number"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="pr-5">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px]" appearance="outline">
            <input readonly="true" matInput type="email" placeholder="Email" />
          </mat-form-field>
        </div>
      </div>

      <div class="pr-5">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px]" appearance="outline">
            <input readonly="true" matInput placeholder="Website" />
          </mat-form-field>
        </div>
      </div>
      <div class="pr-5">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px]" appearance="outline">
            <input
              readonly="true"
              matInput
              type="number"
              placeholder="Telephone #"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="pr-5 !h-[150px]">
        <div class="rounded pr-10">
          <mat-form-field
            class="!w-[500px] !h-[179px] !mb-[0px]"
            appearance="outline"
          >
            <input readonly="true" matInput placeholder="Address" />
          </mat-form-field>
        </div>
      </div>
      <div class="pr-5 !h-[150px]">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px] !mb-[20px]" appearance="outline">
            <input readonly="true" matInput placeholder="City" />
          </mat-form-field>
        </div>
        <div class="rounded pr-10 mt-[26px]">
          <mat-form-field class="!w-[500px] !mb-[0px]" appearance="outline">
            <input readonly="true" matInput placeholder="State/Province" />
          </mat-form-field>
        </div>
      </div>

      <div class="pr-5 mt-[24px]">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px]" appearance="outline">
            <input readonly="true" matInput placeholder="Country" />
          </mat-form-field>
        </div>
      </div>
      <div class="pr-5 mt-[24px]">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px]" appearance="outline">
            <input
              readonly="true"
              matInput
              type="number"
              placeholder="Zip/Postal Code"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div
  class="flex justify-center h-auto p-[29px] !pl-0 !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]"
>
  <div class="!pr-[30px]  !rounded-[15px] w-full">
    <h3 class="text-[20px] font-semibold !pl-0 !mb-[0px] !pt-0">
      Scope of Interest
    </h3>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4">
      <div class="pr-5">
        <div class="rounded pr-10 !mb-[40px]">
          <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
            <input readonly="true" matInput placeholder="Nature of Service" />
          </mat-form-field>
        </div>
      </div>
      <div class="pr-5">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px]" appearance="outline">
            <input readonly="true" matInput placeholder="Expected Start Date" />
          </mat-form-field>
        </div>
      </div>

      <div class="pr-5">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px]" appearance="outline">
            <input readonly="true" matInput placeholder="Type of Project" />
          </mat-form-field>
        </div>
      </div>
      <div class="pr-5">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px]" appearance="outline">
            <input readonly="true" matInput placeholder="Expected End Date" />
          </mat-form-field>
        </div>
      </div>

      <div class="pr-5">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px]" appearance="outline">
            <input readonly="true" matInput placeholder="Project Location" />
          </mat-form-field>
        </div>
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px]" appearance="outline">
            <input
              readonly="true"
              matInput
              type="number"
              placeholder="Estimation Project Value"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div
  class="flex justify-center h-auto p-[29px] !pl-0 !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]"
>
  <div class="!pr-[30px] !rounded-[15px] !w-full">
    <h3 class="text-[20px] font-semibold !pl-0 !mb-[0px] !pt-0">
      Experience & Capability (If Applicable)
    </h3>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
      <div class="pr-5 mb-[0.5rem]">
        <div class="rounded pr-10">
          <mat-form-field class="!w-full" appearance="outline">
            <textarea
              readonly
              matInput
              [rows]="4"
              placeholder="Relevant Experience"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="pl-[10px] cursor-not-allowed flex mt-3">
        <div class="">
          <button
            type="button"
            class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
          >
            <span class="text-[0.7rem]"> Attach Documents </span>
            <img
              class="rounded-full ml-[4px]"
              src="assets/icons/document.svg"
              alt="document icon"
            />
          </button>
        </div>
        <input #fileInput type="file" class="hidden" />
      </div>
      <div class="pr-5 mb-[0.5rem]">
        <div class="rounded pr-10">
          <mat-form-field class="!w-full" appearance="outline">
            <textarea
              readonly="true"
              matInput
              [rows]="4"
              placeholder="Key Qualifications"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="pl-[10px] cursor-not-allowed flex mt-3">
        <div class="">
          <button
            type="button"
            class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
          >
            <span class="text-[0.7rem]"> Attach Documents </span>
            <img
              class="rounded-full ml-[4px]"
              src="assets/icons/document.svg"
              alt="document icon"
            />
          </button>
        </div>
        <input #fileInput type="file" class="hidden" />
      </div>
      <div class="pr-5 mb-[0.5rem]">
        <div class="rounded pr-10">
          <mat-form-field class="!w-full" appearance="outline">
            <textarea
              readonly="true"
              matInput
              [rows]="4"
              placeholder="Team Composition"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="pl-[10px] cursor-not-allowed flex mt-3">
        <div class="">
          <button
            type="button"
            class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
          >
            <span class="text-[0.7rem]"> Attach Documents </span>
            <img
              class="rounded-full ml-[4px]"
              src="assets/icons/document.svg"
              alt="document icon"
            />
          </button>
        </div>
        <input #fileInput type="file" class="hidden" />
      </div>
    </div>
  </div>
</div>

<div
  class="flex justify-center h-auto p-[29px] !pl-0 !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]"
>
  <div class="!pr-[30px] !rounded-[15px] w-full">
    <h3 class="text-[20px] !pb-[20px] font-semibold !pl-0 !mb-[0px] !mt-[20px] !pt-0">
      Compliance & Policies
    </h3>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
      <div class="pr-5">
        <div>
          <p class="text-[1rem] font-semibold !pl-0 !mb-[10px] !pt-0">
            Health, Safety & Environmental Policy
          </p>
          <div class="rounded pr-10">
            <mat-form-field class="w-full" appearance="outline">
              <textarea
                readonly="true"
                matInput
                [rows]="4"
                placeholder="Health, Safety & Environmental Policy"
              ></textarea>
            </mat-form-field>
          </div>
          <div class="pl-[10px] cursor-not-allowed flex mt-[2.4rem] mb-[1rem]">
            <div class="">
              <button
                type="button"
                class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
              >
                <span class="text-[0.7rem]"> Attach Documents </span>
                <img
                  class="rounded-full ml-[4px]"
                  src="assets/icons/document.svg"
                  alt="document icon"
                />
              </button>
            </div>
            <input #fileInput type="file" class="hidden" />
          </div>
        </div>

        <div>
          <p class="text-[1rem] font-semibold !pl-0 !mb-[10px] !pt-0">
            Quality Assurance Certification
          </p>
          <div class="rounded pr-10">
            <mat-form-field class="w-full" appearance="outline">
              <textarea
                readonly="true"
                matInput
                [rows]="4"
                placeholder="Quality Assurance Certification"
              ></textarea>
            </mat-form-field>
          </div>
          <div class="pl-[10px] cursor-not-allowed flex mt-[2.4rem] mb-[1rem]">
            <div class="">
              <button
                type="button"
                class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
              >
                <span class="text-[0.7rem]"> Attach Documents </span>
                <img
                  class="rounded-full ml-[4px]"
                  src="assets/icons/document.svg"
                  alt="document icon"
                />
              </button>
            </div>
            <input #fileInput type="file" class="hidden" />
          </div>
        </div>
        <div>
          <p class="text-[1rem] font-semibold !pl-0  !mb-[10px] !pt-0">
            Conflict of Interest Disclosure
          </p>
          <div class="rounded pr-10">
            <mat-form-field class="w-full" appearance="outline">
              <textarea
                readonly="true"
                matInput
                [rows]="4"
                placeholder="Conflict of Interest Disclosure"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="flex justify-center h-auto p-[29px] !pl-0 !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]"
>
  <div class="!pr-[30px] !rounded-[15px] w-full mt-[3rem]">
    <h3 class="text-[20px] font-semibold !pl-0 !pb-[10px] !mb-[0px] !pt-0">
      Additional Information
    </h3>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1">
      <div class="pr-5">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[100%] !h-[90px]" appearance="outline">
            <textarea
              readonly="true"
              matInput
              [rows]="4"
              placeholder="Additional Information"
            ></textarea>
          </mat-form-field>
          <div class="pl-[10px] cursor-not-allowed flex  mb-[2rem]">
            <div class="">
              <button
                type="button"
                class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
              >
                <span class="text-[0.7rem]"> Attach Documents </span>
                <img
                  class="rounded-full ml-[4px]"
                  src="assets/icons/document.svg"
                  alt="document icon"
                />
              </button>
            </div>
            <input #fileInput type="file" class="hidden" />
          </div>
        </div>
     
      </div>
    </div>
  </div>
</div>

<div
  class="flex justify-center h-auto p-[29px] !pl-0 !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]"
>
  <div class="!pr-[30px] !rounded-[15px] w-full mt-[-45px]">
    <h3 class="text-[20px] font-semibold !pl-0 !pb-[20px] !mt-[20px] !pt-0">Declaration</h3>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 ">
      <!-- <h3 class="!pl-[60px] col-span-12">Applicant Details</h3> -->

      <div class="pr-5">
        <div class="rounded pr-10">
          <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
            <input
              readonly="true"
              matInput
              placeholder="Name of Authorized Representative"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="pr-5">
        <div class="rounded pr-10 !mb-[40px]">
          <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
            <input readonly="true" matInput placeholder="Position" />
          </mat-form-field>
        </div>
      </div>

      <div class="pr-5">
        <div class="rounded pr-10 !mb-[40px]">
          <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
            <input readonly="true" matInput placeholder="Signature" />
          </mat-form-field>
        </div>
      </div>

      <div class="pr-5">
        <div class="rounded pr-10 !mb-[40px]">
          <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
            <input readonly="true" matInput placeholder="Date" />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
